export default __webpack_public_path__ + "static/contact-img-bg-bed69f2b1a731a75871a151ca33f9c9d.png";